import React, { useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import { reactSelectCustomStyle } from 'helper';
import { GET_HOSPITALS } from '../constant';
import * as actions from '../action';

const selectList = ({ api }) => {
  return _.get(api, `${GET_HOSPITALS}.list`) || [];
};

const formatOptions = (data) => {
  return data.map((item) => {
    return {
      label: _.get(item, 'attributes.name'),
      value: _.get(item, 'attributes.code'),
      fullInfo: item,
    };
  });
};

const Hospital = ({ onChange, name, value, readOnly, type, isLoading }) => {
  const dispatch = useDispatch();
  const list = useSelector(selectList);
  const options = formatOptions(list);

  const findValue =
    value === ''
      ? ''
      : options.find(
          (item) => _.get(item, 'fullInfo.attributes.code') === value
        ) || '';

  useEffect(() => {
    dispatch(actions.getHospitals({ display_all: 1, code: value }));
  }, [value]);

  // const handleChange = (data) => {
  //   onChange({
  //     target: {
  //       name,
  //       value: data ? data.value : '',
  //       label: data ? data.label : '',
  //     },
  //   });
  // };

  const loadOptions = (inputValue, callback) => {
    dispatch(
      actions.getHospitals({ q: inputValue }, (response) => {
        callback(formatOptions(_.get(response, 'data')));
      })
    );
  };

  const loadOptionsDebounce = _.debounce(loadOptions, 500);

  return readOnly === true ? (
    <span
      className={`text-uppercase ${
        type === 'mobile' ? 'span-input-mobile' : 'full-input'
      }`}
    >
      {_.get(findValue, 'label')}
    </span>
  ) : (
    <AsyncSelect
      name={name}
      styles={reactSelectCustomStyle}
      isClearable
      placeholder="- Type to Search -"
      value={findValue}
      defaultOptions={formatOptions(list)}
      loadOptions={loadOptionsDebounce}
      onChange={onChange}
      isLoading={isLoading}
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};

Hospital.defaultProps = {
  name: undefined,
  readOnly: undefined,
  type: '',
};

Hospital.propTypes = {
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
  type: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, 'loading', []).indexOf(GET_HOSPITALS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(Hospital);
